import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function KidneyDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Kidney and Urinary Disorder Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>What was the exact diagnosis?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.subQuestions.exactDiagnosis}</p>

                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosis.subQuestions.dateOfDiagnosis)}</p>

                        <Question>Any underlying causes?</Question>
                        <p>{questions.diagnosis.subQuestions.anyUnderlyingCauses}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please provide details of any symptoms in the last 5 years to include frequency, severity, and duration:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.symptoms.referToAttachments}>
                        <OutputDetails
                            details={questions.symptoms.subQuestions.details}
                        />

                        <Question>Date of last symptoms:</Question>
                        <p>{formatDateMonthYear(questions.symptoms.subQuestions.dateOfLastSymptoms)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please confirm the date and result of the latest RFT’s (creatinine, urea, eGFR, ACR, PCR), blood pressure and urinalysis</Question>
                    <ReferrableQuestionWrapper isReferred={questions.rftBloodPressureUrinalysisResults.referToAttachments}>
                        <p>{questions.rftBloodPressureUrinalysisResults.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Date and results of any other investigations? (cystoscopy, CT scan etc.)</Question>
                    <ReferrableQuestionWrapper isReferred={questions.otherInvestigationResults.referToAttachments}>
                        <p>{questions.otherInvestigationResults.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Has your patient required any treatment, including inpatient treatment or surgery in the last 5 years?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyTreatmentRequired.referToAttachments}>
                        <p>{questions.anyTreatmentRequired.value}</p>

                        <Question
                            show={questions.anyTreatmentRequired.value === 'Yes'}
                            answer={questions.anyTreatmentRequired.details}
                        >
                            If yes, please confirm details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Any associated medical conditions or complications?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyAssociatedMedicalConditions.referToAttachments}>
                        <p>{questions.anyAssociatedMedicalConditions.value}</p>

                        {questions.anyAssociatedMedicalConditions.value === 'Yes' && (
                            <>
                                <Question
                                    show={questions.anyAssociatedMedicalConditions.value === 'Yes'}
                                    answer={questions.anyAssociatedMedicalConditions.subQuestions.details}
                                >
                                    If yes, please confirm details
                                </Question>

                                <Question answer={questions.anyAssociatedMedicalConditions.subQuestions.isPatientCompliant}>Is patient compliant with recommended treatment and follow-ups?</Question>

                                <Question
                                    show={questions.anyAssociatedMedicalConditions.subQuestions.isPatientCompliant === 'No'}
                                    answer={questions.anyAssociatedMedicalConditions.subQuestions.isPatientCompliantDetails}
                                >
                                    If no, please provide details:
                                </Question>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Has the condition caused any time off work?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyTimeOffWorkCaused.referToAttachments}>
                        <p>{questions.anyTimeOffWorkCaused.value}</p>
                        <Question
                            show={questions.anyTimeOffWorkCaused.value === 'Yes'}
                            answer={questions.anyTimeOffWorkCaused.details}
                        >
                            If yes, please confirm details
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}